import React, { FunctionComponent, useEffect } from "react";

import * as H from "history";
import { useDispatch } from "react-redux";
import { Router, Switch, Route } from "react-router-dom";

import { clearBreadcrumbs } from "../../features/breadcrumbs/breadcrumbsSlice";
import { ActionSuffixes, Prefixes } from "../prefixes";
import { Courses } from './index';
import { NewCourse } from './new';
import { EditCourse } from './edit';

interface AdminRouterProps {
  history: H.History<any>;
}

const prefix = Prefixes.course;

export const CoursesRouter: FunctionComponent<AdminRouterProps> = ({
  history,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return history.listen((location) => {
      dispatch(clearBreadcrumbs());
    });
  }, [dispatch, history]);
  return <Router history={history}>
    <Switch>
      <Route path={`${prefix}${ActionSuffixes.new}`} exact>
        <NewCourse />
      </Route>
      <Route path={`${prefix}/:id${ActionSuffixes.edit}`} exact>
        <EditCourse />
      </Route>
      <Route path={prefix}>
        <Courses />
      </Route>
    </Switch>
  </Router>;
};